export default class PurchaseOrders {
    constructor(client) {
      this.client = client;
    }
  
    createProductOrder(data) {
      return this.client.post("/purchase_orders", {
        data: { ...data },
      });
    }    
}
  